import styled from "styled-components";
import {useSliMatchApi} from "../../common/hooks/sli/useSliMatchApi";
import React, {useLayoutEffect, useMemo, useState} from "react";
import useSllMatchQueries from "../../common/hooks/sli/useSllMatchQueries";
import SllMatchList from "../sll/SllMatchList";
import {ImageLane} from "../common";
import {MarginBox} from "../ui/styled";

const NotPlayed = styled.div`
  border: 1px solid ${props => props.theme.color.default_border_color};
  background-color: ${props => props.theme.color.site_main_color};
  color: ${props => props.theme.color.dark_100};
  font-size: 16px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
  border-radius: 6px;
`;

const MangMatchContent = ({teamId, team}) => {
    const {list} = useSliMatchApi({teamId, team,tournamentName:'mgh2'})


    if (list?.matches?.length === 0) {
        return (
            <NotPlayed>
                아직 플레이한 스크림이 없습니다.
            </NotPlayed>
        )
    }

    return (
        <div>
            <SllMatches playerList={list.team_match_data} matchList={list.matches} mercenaryList={list.mercenary}/>
        </div>
    );
};

const MatchesWrapper = styled.div`
  background-color: ${props => props.theme.color.site_main_color};

  border: 1px solid ${props => props.theme.color.default_border_color};
  border-radius: 6px;
  overflow: hidden;
`;
const MatchBorderBox = styled.div`
  margin: 0 10px;
  border-top: 1px solid ${props => props.theme.color.default_border_color};
`;
const MoreButton = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  margin-top: 6px;
  background: ${props => props.theme.color.site_main_color};
  font-size: 16px;
  color: ${props => props.theme.color.dark_200};
  text-align: center;
  border: 1px solid ${props => props.theme.color.default_border_color};
  border-radius: 6px;

  &:hover {
    background-color: ${props => props.theme.color.white_201};
  }

`;
const MATCH_COUNT = 6
const SllMatches = ({playerList, mercenaryList}) => {
    const [selected, setSelected] = useState(playerList[0]);
    const [page, setPage] = useState(1);
    const [matches, setMatches] = useState([])

    const matchIds = useMemo(() => {
        try {
            const sliceCount = page * MATCH_COUNT
            const copyArray = [...selected.match_ids];
            return copyArray.slice(0, sliceCount)
        } catch (e) {
            return []
        }
    }, [page, selected])
    const handleSetSelected = (value) => {
        if (value !== selected) {
            setSelected(value)
            setPage(1)
            setMatches([])
        }
    }

    useLayoutEffect(() => {
        if (playerList[0]) {
            handleSetSelected(playerList[0])
        }
    }, [playerList]);

    const {matchList} = useSllMatchQueries({list: matchIds})
    useLayoutEffect(() => {
        if (matchIds && !matchList.pending) {
            setMatches(matchList.data)
        }
    }, [matchList.pending, matchIds])


    return (
        <div>

            <MatchesWrapper>
                <PlayerWinLose list={playerList} selected={selected} setSelected={handleSetSelected}/>
                <SllMercenary list={mercenaryList} selected={selected} setSelected={handleSetSelected}/>
                {(matches.length > 0) ?
                    <MatchBorderBox>
                        <SllMatchList matchList={matches} targetSummoner={selected}
                                      isMore={matchIds.length < selected?.match_ids?.length}
                                      teamLuckMode={true}
                        />
                    </MatchBorderBox>
                    : null
                }
            </MatchesWrapper>

            {matchIds.length < selected?.match_ids?.length &&
                <MoreButton
                    onClick={() => setPage(prev => prev + 1)}
                >
                    <span>더보기</span>
                </MoreButton>}
        </div>
    )
}

const HeaderTr = styled.tr`
  height: 36px;
  background-color: ${props => props.theme.color.white_200};
  border-bottom: 1px solid ${props => props.theme.color.default_border_color};
`;
const HeaderTh = styled.th`
  font-weight: 700;
  font-size: 12px;
  text-align: center;
  position: relative;
  vertical-align: middle;
  color: ${props => props.theme.color.dark_100};
`;
const Table = styled.table`
  width: 100%;

  .imgLane {
    width: 20px;
    height: 20px;
  }
`;


const BodyTr = styled.tr`
  height: 100px;

  background-color: ${props => {
    let color = 'transparent';
    if (props.selected) {
        color = props.theme.color.green_200
    }
    return color;
}};


`;
const BodyTd = styled.td`
  vertical-align: middle;
`;

const RankSpan = styled.span`
  font-weight: 700;
  font-size: 18px;
`;
const SmallRankSpan = styled.span`
  font-weight: 700;
  font-size: 8px;
`;

const TdBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;
const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
`;
const BorderBox = styled.div`
  padding: 6px 8px;
  border: 1px solid ${props => {
    let color = 'transparent';
    if (props.selected) {
        color = props.theme.color.green_100
    }
    return color
}};
  border-radius: 8px;
`;
const PlayerImage = styled.img`
  border-radius: 4px;
  object-fit: cover;
`;
const PlayerName = styled.div`
  display: flex;
  justify-content: center;
  height: 14.5px;
  width: 48px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;

`;

const EmptyTh = styled.th`
  width: 180px;
`;

const EndBox = styled.div`
  width: 100%;
  height: 80px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-end;
`;
const PlayerNameSpan = styled.span`
  color: ${props => props.theme.color.dark_200};
  font-weight: 600;
  font-size: 14px;
  margin-right: 10px;
`;
const WinLoseSpan = styled.span`
  margin-left: 4px;
  color: ${props => props.theme.color.dark_100};
  font-weight: 600;
  font-size: 14px;
`;
const EmptyBox = styled.div`
  width: 48px;
  height: 48px;
`;
const PlayerWinLose = ({list, selected, setSelected}) => {


    return (
        <Table>
            <thead>
            <HeaderTr>
                <HeaderTh>
                    <ImageLane
                        color={'dark'}
                        lane={'top'}
                    />
                </HeaderTh>
                <HeaderTh><ImageLane
                    color={'dark'}
                    lane={'jungle'}
                />
                </HeaderTh>
                <HeaderTh>
                    <ImageLane
                        color={'dark'}
                        lane={'middle'}
                    />
                </HeaderTh>
                <HeaderTh>
                    <ImageLane
                        color={'dark'}
                        lane={'bot'}
                    />
                </HeaderTh>
                <HeaderTh>
                    <ImageLane
                        color={'dark'}
                        lane={'supporter'}
                    />
                </HeaderTh>
                <EmptyTh/>
            </HeaderTr>
            </thead>
            <tbody>
            <BodyTr>
                {Array.from({length: 5}).map((_, index) => {
                    const data = list[index]
                    if (!data) {
                        return (
                            <td key={index}>
                                <EmptyBox/>
                            </td>
                        )
                    }
                    return (
                        <BodyTd key={index} onClick={() => setSelected(data)}>

                            <Column>
                                <BorderBox selected={data.name === selected.name}>
                                    <MarginBox margin={'0 0 4px 0'}>
                                        <PlayerImage
                                            src={`https://ak-deeplol-ddragon-cdn.deeplol.gg/${data?.status?.toLowerCase()}/${data?.status === 'pro' ? data?.championship_name : data?.name}.png`}
                                            width={48}
                                            height={48}
                                            onError={(e) => e.target.src = '/images/sll/sll_empty_profile.svg'}
                                            alt={''}/>
                                    </MarginBox>
                                    <PlayerName>
                                        <PlayerSpan
                                            selected={data?.name === selected?.name}>{data?.name ? data?.name : data?.riot_id_name}</PlayerSpan>
                                    </PlayerName>
                                </BorderBox>
                            </Column>
                        </BodyTd>
                    )
                })}
                <BodyTd>
                    <EndBox>
                        <PlayerNameSpan>
                            {selected?.name}:<WinLoseSpan>{selected?.win}승 {selected?.loss}패</WinLoseSpan>
                        </PlayerNameSpan>
                    </EndBox>
                </BodyTd>
            </BodyTr>
            </tbody>
        </Table>
    )
}

const MercenaryWrapper = styled.div`
  margin: 0 10px;
  display: flex;
  align-items: center;
  height: 111px;
  border-top: 1px solid ${props => props.theme.color.default_border_color};
`;
const MercenaryBar = styled.div`
  height: 36px;
  width: 1px;
  background-color: ${props => props.theme.color.green_100};
`;

const MercenarySpan = styled.span`
  font-size: 12px;
  color: ${props => props.theme.color.dark_200};
  font-weight: 500;
  margin: 0 8px 0 4px;
`;

const PlayerListBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  margin: 0 0 0 8px;
`;
const ExplainText = styled.div`
  font-weight: 600;
  font-size: 12px;
  color: ${props => props.theme.color.dark_200};
  margin-left: 8px;
`;
const SllMercenary = ({list, selected, setSelected}) => {
        if (list?.length < 1) {
            return null
        }
        return (
            <MercenaryWrapper>
                <MercenarySpan>
                    용병
                </MercenarySpan>
                <MercenaryBar/>
                <PlayerListBox>
                    {list.map((data, index) => {
                        return (
                            <button key={index}>
                                <BorderBox selected={data?.name === selected?.name} onClick={() => setSelected(data)}>
                                    <MarginBox margin={'0 0 4px 0'}>
                                        <PlayerImage
                                            src={`https://ak-deeplol-ddragon-cdn.deeplol.gg/${data.status.toLowerCase()}/${data.status === 'pro' ? data.championship_name : data.name}.png`}
                                            width={48}
                                            height={48}
                                            onError={(e) => e.target.src = '/images/sll/sll_empty_profile.svg'}
                                            alt={''}/>
                                    </MarginBox>
                                    <PlayerName>
                                        <PlayerSpan
                                            selected={data?.name === selected?.name}>{data?.name ? data?.name : data?.riot_id_name}</PlayerSpan>
                                    </PlayerName>
                                </BorderBox>
                            </button>
                        )
                    })}
                </PlayerListBox>
            </MercenaryWrapper>
        )
    }

;


// const ContentWrapper = styled.div`
//   display: flex;
//   flex-direction: row;
//   align-items: center;
//   justify-content: flex-start;
// `
// const ContentDot = styled.span`
//   font-weight: 600;
//   font-size: 14px;
// `;
// const TeamBox = styled.div`
//   display: flex;
//   flex-direction: row;
//   align-items: center;
//   margin-left: 4px;
// `;
const TeamSpan = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  color: ${props => props.theme.color.dark_100};
  font-weight: 600;
  font-size: 12px;
`;

// const LimitedSpan = styled.span`
//   max-width: 60px;
//   white-space: nowrap;
//   overflow: hidden;
//   text-overflow: ellipsis;
// `;
const PlayerSpan = styled(TeamSpan)`
  color: ${props => {
    let color = props.theme.color.dark_200
    if (props.selected) {
        color = props.theme.color.dark_100
    }
    return color
}};
`;
// const TeamLittleSpan = styled.span`
//   font-weight: 400;
//   font-size: 10px;
//   color: ${props => props.theme.color.dark_200};
//   margin-left: 2px;
// `;
// const VersusText = styled.span`
//   font-weight: 500;
//   font-size: 10px;
//   color: ${props => props.theme.color.green_100};
//   margin: 0 4px;
// `;
//
// const ScoreBox = styled.div`
//   display: flex;
//   flex-direction: row;
//   align-items: center;
//   padding: 2px 4px;
//   border-radius: 2px;
// `;

// const WinScoreBox = styled(ScoreBox)`
//   background-color: #357CE5;
// `;
// const LoseScoreBox = styled(ScoreBox)`
//   background-color: #D64848;
// `;
// const ScoreText = styled.span`
//   font-weight: 600;
//   font-size: 12px;
//   color: #fff;
// `;
// const ScoreSmallSpan = styled.span`
//   font-weight: 600;
//   font-size: 8px;
//   color: #fff;
//   margin-left: 1px;
// `;
//
// const OverviewContent = ({data, teamName}) => {
//     return (
//         <ContentWrapper>
//             <ContentDot>
//                 ㆍ
//             </ContentDot>
//             <TeamBox>
//                 <TeamSpan>
//                     <LimitedSpan>{teamName}</LimitedSpan>
//                     <TeamLittleSpan>
//                         team
//                     </TeamLittleSpan>
//                 </TeamSpan>
//                 <VersusText>
//                     vs
//                 </VersusText>
//                 <TeamSpan>
//                     <LimitedSpan>{data.team_name}</LimitedSpan>
//                     <TeamLittleSpan>
//                         team
//                     </TeamLittleSpan>
//                 </TeamSpan>
//             </TeamBox>
//             <MarginBox margin={'0 4px'}>
//                 <TeamSpan>
//                     ≫
//                 </TeamSpan>
//             </MarginBox>
//             <MarginBox>
//                 <WinScoreBox>
//                     <ScoreText>
//                         {data.win}
//                     </ScoreText>
//                     <ScoreSmallSpan>
//                         승
//                     </ScoreSmallSpan>
//                 </WinScoreBox>
//             </MarginBox>
//
//             <MarginBox margin={'0 0 0 8px'}>
//                 <LoseScoreBox>
//                     <ScoreText>
//                         {data.loss}
//                     </ScoreText>
//                     <ScoreSmallSpan>
//                         패
//                     </ScoreSmallSpan>
//                 </LoseScoreBox>
//             </MarginBox>
//         </ContentWrapper>
//     )
// }

export default MangMatchContent;